export default __webpack_public_path__ + "static/media/rgp_pvh_nca_almati_bw.6e7139ac.png";